// extracted by mini-css-extract-plugin
export default {"component":"FooterSpacer__component-cg6c","line":"FooterSpacer__line-Gzrm"};